// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"957bc679","13":"812727bd","316":"1ec5a349","433":"812a4efb"}[chunkId] + ".chunk.js";
};